<template>
  <div>
    <UserNotifications
      v-if="showUserNotifications"
      :id="showUserNotifications"
      :showDelete="true"
    ></UserNotifications>
    <div id="wrapper">
      <notifications></notifications>
      <div id="sidebar-wrapper">
        <ul class="sidebar-nav">
          <a class="menu-icon" href="/#/dashboard">
            <img :src="logo" />
          </a>

          <li v-for="item in items" :class="getClass(item)">
            <a href="#" @click.prevent="navClicked(item)"
              ><i :class="item.class"></i>{{ item.label }}</a
            >
          </li>
        </ul>
      </div>
      <div id="page-content-wrapper">
        <div class="page-content">
          <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

          <div class="container-fluid">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import UserNotifications from "@/views/Components/UserNotifications/UserNotifications.vue";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
    UserNotifications,
  },
  inject: ["hasRole", "systemContextService"],
  data() {
    return {
      logo: null,
      totalApprovedAmount: null,
      paymentPlanAmount: null,
      virtualAndTerminalAmount: null,
      textToPayAmount: null,
      membershipAmount: null,
      showUserNotifications: null,
      paymentPageAmount: null,
      items: null,
    };
  },
  watch: {
    $route(to, from) {
      this.setActive(to);
    },
  },
  created() {
    this.$emitter.on("show-userNotification", (id) => {
      this.showUserNotifications = id;
    });

    this.$emitter.on("hide-userNotification", (id) => {
      this.showUserNotifications = id;
    });

    var systemContext = this.systemContextService.getSystem();

    this.logo = systemContext.dashboardImageUrl;

    this.items = [];

    this.items.push({
      isActive: false,
      label: "Dashboard",
      class: "icomoon icon-dashboard",
      href: "/#/dashboard",
    });

    this.items.push({
      isActive: false,
      label: "Transactions",
      class: "icomoon icon-transactions",
      href: "/#/transactions",
    });

    if (this.hasRole("BETA")) {
      this.items.push({
        isActive: false,
        label: "Appointments",
        class: "fa-regular fa-calendar",
        href: "/#/appts/schedule",
      });
    }

    if (this.hasRole("VIEWPAYMENTREQUESTS")) {
      this.items.push({
        isActive: false,
        label: "Payment Requests",
        class: "icomoon icon-text",
        href: "/#/notifications",
      });
    }

    if (this.hasRole("VIEWPAYMENTPLANS")) {
      this.items.push({
        isActive: false,
        label: "Payment Plans",
        class: "icomoon icon-recurring",
        href: "/#/paymentplans",
      });
    }

    if (this.hasRole("VIEWMEMBERSHIPS")) {
      this.items.push({
        isActive: false,
        label: "Memberships",
        class: "icomoon icon-membership",
        href: "/#/customermembershipbillings",
      });
    }
  },
  methods: {
    setActive(to) {
      //todo
      this.items.forEach((e) => {
        e.isActive = false;
      });
      // });

      if (to.path == "/dashboard") this.items[0].isActive = true;
      if (to.path == "/transactions") this.items[1].isActive = true;
      if (to.path == "/notifications") this.items[2].isActive = true;
      if (to.path == "/paymentplans") this.items[3].isActive = true;
      if (to.path == "/customermembershipbillings")
        this.items[4].isActive = true;
    },
    getClass(item) {
      let c = "";

      if (item.isActive === true) c = "active";

      return c;
    },
    navClicked(item) {
      location.href = item.href;
    },
  },
  mounted() {
    this.setActive({ path: this.$route.path });
  },
};
</script>

<style scope>
#wrapper {
  padding-left: 150px;
}

.menu-icon img {
  width: 55px;
}

#sidebar-wrapper {
  margin-left: -150px;
  left: 155px;
  width: 150px;
  position: fixed;
  height: 100%;
  overflow-y: auto;
  z-index: 1000;
}

#page-content-wrapper {
  width: 100%;
}
</style>
